import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type {
  AdminListFiatTransactionsParams,
  AdminCompleteWithdrawalFiatInput,
  AdminBackofficeFiatDepositInput,
} from '../api'
import type { IMutationArgs } from '../types'
import { adminListFiatTransactionsOptions } from './admin-payment.options'
import adminPaymentService from './admin-payment.service'
import { EPaymentQueryKey } from './admin-payment.types'

export const useAdminListFiatTransactions = (
  params: AdminListFiatTransactionsParams,
) => {
  return useQuery(adminListFiatTransactionsOptions(params))
}

export const useAdminCompleteWithdrawalFiat = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: AdminCompleteWithdrawalFiatInput) =>
      adminPaymentService.adminCompleteFiatWithdrawal(data),
    mutationKey: [EPaymentQueryKey.ADMIN_COMPLETE_WITHDRAWAL_FIAT],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EPaymentQueryKey.ADMIN_LIST_FIAT_TRANSACTIONS],
        })
      return data
    },
  })
}

export const useAdminFiatDeposit = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: AdminBackofficeFiatDepositInput) =>
      adminPaymentService.adminFiatDeposit(data),
    mutationKey: [EPaymentQueryKey.ADMIN_FIAT_DEPOSIT],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EPaymentQueryKey.ADMIN_LIST_FIAT_TRANSACTIONS],
        })
      return data
    },
  })
}
